import { DateTime } from 'luxon';
import React from 'react';

import Comunicado from 'Interface/Comunicados';

interface Props {
  dados: Comunicado;
  indice: number;
}

const Default = ({ dados, indice }: Props): React.ReactElement => {
  return (
    <div className={indice > 0 ? 'border-top pt-3' : ''}>
      <p className="fs-5 fw-bold mb-0 mt-0">{dados.assunto}</p>
      <small className="text-muted d-block mb-3">
        Por <b>{dados.usuario?.nome}</b> as{' '}
        {dados.modificado.data().toLocaleString(DateTime.DATETIME_SHORT)}
      </small>
      <p style={{ whiteSpace: 'pre-wrap' }}>{dados.mensagem}</p>
      {dados.arquivo && (
        <a
          href={dados.arquivo}
          className="btn btn-success"
          target="_blank"
          rel="noreferrer"
        >
          Download do arquivo
        </a>
      )}
    </div>
  );
};

export default Default;
